import { makeStyles } from '@material-ui/core';

import { tiptapBlockMarginBottom, tiptapBlockMarginTop } from '../editorStyles';

export const useImageCardStyles = makeStyles(() => ({
  card: {
    backgroundColor: 'var(--bui-bg-neutral-2)',
    border: '1px solid transparent',
    borderRadius: 'var(--bui-radius-4)',
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    marginBottom: tiptapBlockMarginBottom,
    marginTop: tiptapBlockMarginTop,
    position: 'relative',
    width: '100%',
    '&:hover': {
      borderColor: 'var(--bui-border)',
    },
    '& $hoverToolbar': {
      opacity: 0,
      pointerEvents: 'none' as const,
    },
    '&:hover $hoverToolbar, &$cardFocused $hoverToolbar, &:focus-within $hoverToolbar':
      {
        opacity: 1,
        pointerEvents: 'auto' as const,
      },
  },
  hoverToolbar: {
    position: 'absolute' as const,
    top: 0,
    right: 0,
    transform: 'translateY(-100%)',
    paddingBottom: 8,
    zIndex: 1000,
  },
  cardFocused: {
    '&, &:hover': {
      borderColor: 'var(--bui-border-pressed)',
    },
  },
  imageContainer: {
    alignItems: 'center',
    backgroundColor: 'var(--bui-bg-tint)',
    borderRadius: 'var(--bui-radius-4) var(--bui-radius-4) 0 0',
    display: 'flex',
    justifyContent: 'center',
    minHeight: 225,
    overflow: 'hidden',
    position: 'relative',
    width: '100%',
  },
  image: {
    display: 'block',
    height: 'auto',
    objectFit: 'cover',
    maxHeight: 225,
    width: '100%',
  },
  imageButton: {
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    width: '100%',
    position: 'relative' as const,
    '& > [data-image-overlay]': {
      opacity: 0,
      transition: 'opacity 150ms ease-in-out',
    },
    '&:hover > [data-image-overlay]': {
      opacity: 1,
    },
  },
  imageOverlay: {
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    bottom: 0,
    color: 'white',
    display: 'flex',
    justifyContent: 'center',
    left: 0,
    position: 'absolute' as const,
    right: 0,
    top: 0,
  },
  imagePlaceholder: {
    alignItems: 'center',
    backgroundColor: 'var(--bui-bg-tint-hover)',
    border: 'none',
    color: 'var(--bui-fg-primary)',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    minHeight: 225,
    width: '100%',
    '&:hover': {
      backgroundColor: 'var(--bui-bg-tint-pressed)',
      color: 'var(--bui-fg-primary)',
    },
  },
  imagePlaceholderStatic: {
    alignItems: 'center',
    color: 'var(--bui-fg-disabled)',
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--bui-space-2)',
    height: '100%',
    justifyContent: 'center',
    borderBottom: '1px solid var(--bui-border)',
    minHeight: 225,
    width: '100%',
  },
  hiddenFileInput: {
    display: 'none',
  },
  contentContainer: {
    display: 'flex',
    gap: 'var(--bui-space-2)',
    flexDirection: 'column',
    padding: 'var(--bui-space-4)',
    '& > h2, & > h3': {
      color: 'var(--bui-fg-primary)',
      fontSize: 'var(--bui-font-size-5)',
      fontWeight: 600,
      margin: 0,
    },
    '& > p': {
      color: 'var(--bui-fg-secondary)',
      fontSize: 'var(--bui-font-size-3)',
      lineHeight: 1.5,
      margin: 0,
    },
  },
}));
